module.exports = __webpack_public_path__ + "static/media/marketing.87c6e4ad.png";